import * as React from "react";
import { Card, CardContent, CardHeader } from '@material-ui/core';

export default () => (
  <Card>
    <CardHeader title="Welcome to the awesome Cinderbuild Admin system" />
    <CardContent>Let's get some work done</CardContent>
  </Card>
);
